var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-nr",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "nr-a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M-54.7 0H628v512H-54.7z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    clipPath: "url(#nr-a)",
    transform: "translate(51.3)scale(.9375)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#002170",
    d: "M-140 0H884v512H-140z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb20d",
    d: "M-140 234.1H884V278H-140z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m161.8 438-33-33-10.5 45.4-12-45-31.9 34 12.1-45L42 407.9l33-33-45.4-10.6 45-12-34-31.8 45 12L72 288l33 33 10.6-45.4 12 45 31.8-34-12 45 44.5-13.5-33 33 45.4 10.5-45 12 34 32-45-12.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNr);
export default __webpack_public_path__ + "static/media/nr.0d87ce78609053fbd9c4f63bef208df9.svg";
export { ForwardRef as ReactComponent };